import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../../../redux/store';
import { Navigate, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { ApplicationModel } from '../../../types/models/ApplicationModel';
import { getApplicationById } from '../../../redux/slices/applicationsSlice';
import back from '../../../assets/images/back.png';
import { PageUrl } from '../../../utils/app-config.ts';


const ViewApplications: React.FC = () => {
    const { id } = useParams<{ id: string }>();
     const dispatch = useDispatch<AppDispatch>();
     
     const [title, setTitle] = useState<string>('');
     const application = useSelector((state: any) => state.applications.data);
    useEffect(() => {
        if (id) {
        dispatch(getApplicationById({ id }));
        }
    }, [id, dispatch]);
   
    useEffect(() => {
        if (application) {
            setTitle(application[0].title); // Set the fetched title to the state
        }
    }, [application]);

    const [newItem1, setNewItem1] = useState('');
    const [newItem2, setNewItem2] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

    };
    const navigate = useNavigate();

    const handleNavigation = () => {
        navigate(PageUrl.ApplicationPage);
    };
    const handleAdd = () => {
        if (newItem2.trim() !== '') {
            setNewItem2('');
        } else {
            alert('Please enter a valid item');
        }
    };


    return (
        <div style={{ maxWidth: '1450px', margin: '20px auto', padding: '20px', borderRadius: '8px', fontWeight: 'bold' }} >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}><h3> View Application</h3>
            <h6 className="back-to-list" onClick={handleNavigation}>
                <img src={back}></img>
                    Back to List
                </h6>

            </div>
            {/* <hr /> */}
            <div style={{ maxWidth: '1450px', margin: '20px auto', padding: '20px', border: '1px solid #ccc', borderRadius: '1px', backgroundColor: '#white' }}>
                {/* <h1 style={{ textAlign: 'left', marginBottom: '20px', borderLeft: "5px solid rgb(224, 105, 14)", padding: "10px" }}>View</h1> */}
                <form onSubmit={handleSubmit}>
                    <label
                        htmlFor="newItem1"
                        style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: 'gray' }}
                    >
                        Title 
                    </label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '110px' }}>

                        <div>
                            <input
                                type="text"
                                id="newItem1"
                                disabled
                                value={title}
                                onChange={(e) => setNewItem1(e.target.value)}
                                required
                                style={{
                                    // width: '1225px',
                                    height: '52px',
                                    padding: '8px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                }}
                            />
                        </div>
                    </div>

                    <div style={{ textAlign: 'left' }}>
                        <label style={{ display: 'block', marginBottom: '5px', marginTop: '15px', color: 'gray' }}>Attachments</label>
                        <button
                            style={{
                                padding: '15px 70px',
                                backgroundColor: '#',
                                color: 'black',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                marginBottom: '15px',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                            }}
                            onClick={() => alert('Button clicked')}
                        >
                            Download
                        </button>


                        <div >

                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ViewApplications;



